import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestGroup} from "../../../redux/Actions/group.action";
import {
  getGroupsList,
  getGroupsTotalCount,
  getGroupsginationUrls,
} from "../../../redux/Selectors/group.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {groupListURL} from "./groupTable.constants";

export const useFetchGroups = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestGroup());
  };

  const refetch = () => {
    dispatch(requestGroup(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useGroupTableData = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const {refetch, freshFetch} = useFetchGroups();
  const {setPageUrl} = usePageURLContext();
  const groups = useSelector(getGroupsList);
  const groupsUrls = useSelector(getGroupsginationUrls);
  const groupsTotalCount = useSelector(getGroupsTotalCount);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (groups.length === 1) {
      // If the last group on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? groupsUrls?.nextUrl : groupsUrls?.prevUrl;
    dispatch(requestGroup(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(groupListURL, tokens);
      dispatch(requestGroup(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };
  return {fetchAfterDelete, handleSearch, paginationConfig, groups, groupsTotalCount};
};
